"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultsTable = ResultsTable;
const React = __importStar(require("react"));
const AmountFormatSelector = __importStar(require("@genesys/client-core/lib/amount-format-selector"));
const ScreenAmountProfile = __importStar(require("@genesys/client-core/lib/screen-amount-profile"));
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const QuantityConversion = __importStar(require("@genesys/shared/lib/quantity-conversion"));
const field_groups_1 = require("../../field-groups");
const ResultTable = __importStar(require("../result-table"));
const Elements = __importStar(require("./elements"));
/**
 * The results, one column per result and one row per calculated case.
 *
 * The unit sits on its own row and is the format selector, so a column is read and re-scaled in
 * the same place. The picker used to sit beside every value, which meant one per value rather
 * than one per column.
 */
function ResultsTable({ results, resultDefinitions }) {
    const [activeSelector, setActiveSelector] = React.useState(undefined);
    return (React.createElement(Contexts.TranslateContext.Consumer, null, translate => (React.createElement(ScreenAmountProfile.ScreenAmountProfile, null, ({ deleteAmountFieldFormat, getPropertyFormats, measureSystem, quantityDefaults, saveAmountFieldFormat }) => {
        const properties = results.length > 0 ? results[0].result : undefined;
        if (!properties) {
            return React.createElement("div", null);
        }
        const formats = getPropertyFormats(field_groups_1.FieldGroup.results, properties);
        const columns = ResultTable.columns(resultDefinitions, results, formats, translate);
        const onFormatChanged = (propertyName, 
        // The selector hands back a unit of an unknown quantity, the same as it does to
        // the properties selector this table replaces.
        unit, decimalCount) => saveAmountFieldFormat(field_groups_1.FieldGroup.results, propertyName, unit, decimalCount);
        return (React.createElement(Elements.ResultsScroller, null,
            React.createElement(Elements.ResultsTable, null,
                React.createElement("thead", null,
                    React.createElement("tr", null, columns.map(column => (React.createElement(Elements.HeaderCell, { key: column.propertyName },
                        React.createElement(Elements.HeaderName, null, column.label),
                        column.type === "amount" ? (React.createElement(AmountFormatSelector.FormatSelectorRenderer, { onFormatSelectorActiveChanged: active => setActiveSelector(active ? column.propertyName : undefined), onFormatChanged: (unit, decimalCount) => onFormatChanged(column.propertyName, unit, decimalCount), onFormatCleared: () => deleteAmountFieldFormat(field_groups_1.FieldGroup.results, column.propertyName), onQuantityChange: QuantityConversion.createOnQuantityChange(onFormatChanged, measureSystem, quantityDefaults, column.propertyName), selectedUnit: column.selectedUnit, selectedDecimalCount: column.selectedDecimalCount, userSelected: column.userSelected, isQuantitySelectorActive: activeSelector === column.propertyName, propertyType: column.type, AmountFormatSelector: AmountFormatSelector.AmountFormatSelectorWithPadding })) : null))))),
                React.createElement("tbody", null, results.map((result, i) => (
                // A case has no identity of its own; its position in the run names it.
                React.createElement("tr", { key: i }, columns.map(column => (React.createElement(Elements.ValueCell, { key: column.propertyName }, ResultTable.cell(column.propertyName, result.result, formats) || " "))))))))));
    }))));
}
//# sourceMappingURL=results-table.js.map